export const ROLE_ADMIN = "admin";
export const ROLE_CUSTOMER = "customer";
export const ROLE_GROUP_ADMIN = "groupadmin";
export const ROLE_ENTITY_ADMIN = "entityadmin";
export const ROLE_AR_REP = "arrep";
export const ROLE_AP_REP = "aprep";
export const ROLE_USER = "user";
export const ROLE_SUPER_ADMIN = "superadmin";
export const ROLE_SUPPLIER = "supplier";
export const ROLE_DRIVER_ACTIVITY_ADMIN = "driveractivityadmin";
export const ROLE_READ_ONLY_USER = "readonlyuser";
export const ROLE_READ_ONLY_ENTITY = "readonlyentityuser";
export const ROLE_READ_ONLY_AR_USER = "readonlyaruser";
export const ROLE_CUSTOMER_INVOICE_RESTRICTED = "customer_invoice_restricted";
export const ROLE_SUPPORT_ADMIN = "supportadmin";
export const ROLE_PAY_ADMIN = "payadmin";
